export default __webpack_public_path__ + "static/media/overview-bg.822bb90b.png";